export const CCALD_DASHBOARD = 'dashboard';
export const CCALD_REPORT_LIST = 'reports';
export const CCALD_CONTACTS_LIST = 'contact';
export const CCALD_CONTRACTS_LIST = 'contracts';
export const CCALD_CONTRACTS_DETAILS = 'details';
export const CCALD_IMPORT_CONTRACTS = 'import-contracts';
export const CCALD_SETTINGS = 'settings';
